var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';
import { TranslationsService } from '../services';
import { LocaleService } from '../../http';
export const getTranslations = createAsyncThunk('core/translations/getTranslations', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue, extra: { inject } }) {
    try {
        const translationsService = inject(TranslationsService);
        const localeService = inject(LocaleService);
        const translations = yield translationsService.getTranslations();
        yield translationsService.addTranslations(localeService.get(), translations);
    }
    catch (err) {
        return rejectWithValue(classToPlain(err));
    }
}));
export const translationsReducers = (builder) => {
    builder.addCase(getTranslations.pending, (state) => {
        state.loading = 'loading';
    });
    builder.addCase(getTranslations.fulfilled, (state) => {
        state.loading = 'complete';
    });
    builder.addCase(getTranslations.rejected, (state, { payload, error }) => {
        state.loading = 'failed';
        state.error =
            payload ||
                {
                    info: (error && error.message) || 'Unknown error',
                    status: 500,
                    source: 'client',
                    title: 'Internal client error',
                };
    });
};
